import type { RootState, WebSocketState } from "@/types";
import type { ActionTree } from "vuex";
import { getAccessToken } from "@/services/authentification";
import {
  HOSTS,
  DOWNLOADREQUEST,
  VALIDATEMANUALDATAFILE,
  UPLOADMANUALDATA,
  DOWNLOADMANUALDATA,
  MULTIVARIATEREGRESSION,
} from "@/constants";
import {
  ACTIV_MANUAL_DATA,
  DISCONNECT_WS,
  INIT_MANUAL_DATA,
  LOAD_NEW_MESSAGE,
  LOAD_WS,
  SEND_IMPORT_REQUEST,
  VALIDATE_MANUAL_DATA,
} from "./mutations";
import { ElNotification } from "element-plus";
import { translate } from "@/i18n";

let wss: WebSocket;
export const actions: ActionTree<WebSocketState, RootState> = {
  connectWs({ commit, dispatch }, dataTosend?: any) {
    let pingIntervalId: any;
    wss = new WebSocket(`${HOSTS.WSS}?ApiKey=Bearer ${getAccessToken()}`);

    wss.onopen = () => {
      if (dataTosend) {
        commit(SEND_IMPORT_REQUEST, dataTosend);
      }
      pingIntervalId = setInterval(() => {
        wss.send(JSON.stringify({ action: "ping" }));
      }, 600000);
    };

    wss.onmessage = (ss: MessageEvent<any>) => {
      const data = JSON.parse(ss.data);
      if (data.type === DOWNLOADREQUEST) {
        ElNotification({
          title: "Téléchargement prêt",
          dangerouslyUseHTMLString: true,
          message: "<strong>Votre téléchargement est en cours ...</strong>",
          type: "success",
        });
        commit(LOAD_NEW_MESSAGE, data);
        dispatch("selfData/downloadFiles", data.id, {
          root: true,
        });
      }
      if (data.type === DOWNLOADMANUALDATA) {
        ElNotification({
          title: "Téléchargement prêt",
          dangerouslyUseHTMLString: true,
          message: "<strong>Votre téléchargement est en cours ...</strong>",
          type: "success",
        });
        window.location.assign(data.message.url);
      }
      if (data.type === UPLOADMANUALDATA) {
        dispatch("selfData/updateImportFile", data.message, {
          root: true,
        });
        commit(ACTIV_MANUAL_DATA);
      }
      if (data.type === VALIDATEMANUALDATAFILE) {
        ElNotification({
          title: "Etat d'import",
          dangerouslyUseHTMLString: true,
          message: translate(data.message),
          type: data.status,
        });
        commit(VALIDATE_MANUAL_DATA, data);
      }
      if (data === "/pong") {
        console.log("La connexion ws est active");
      }
      if (data.type === MULTIVARIATEREGRESSION) {
        dispatch("dataAnalytics/updateModelingResult", data, { root: true });
      }
    };
    wss.onclose = () => {
      clearInterval(pingIntervalId);
    };

    commit(LOAD_WS, wss);
  },

  uploadFileWs({ commit, dispatch }, data: any) {
    commit(INIT_MANUAL_DATA);
    if (wss.readyState !== WebSocket.OPEN) {
      dispatch("ws/connectWs", data, { root: true });
    } else {
      commit(SEND_IMPORT_REQUEST, data);
    }
  },

  sendMultiVariateRequest({ commit, dispatch }, data: any) {
    if (wss.readyState !== WebSocket.OPEN) {
      console.log("La connexion WebSocket n'est pas établie");
      dispatch("ws/connectWs", data, { root: true });
    } else {
      commit(SEND_IMPORT_REQUEST, data);
    }
  },

  createNewConnexion({ commit, dispatch }) {
    commit(DISCONNECT_WS);
    dispatch("ws/connectWs", null, { root: true });
  },

  disconnectWs({ commit }) {
    commit(DISCONNECT_WS);
  },
};
